export const getIsLoadingMore = state => state.search.isLoadingMore;
